/**
 * Beschriftung der Projekt-Zeile — rein, ohne DOM. (05.10.2026 als Chip der Kopfleiste,
 * seit 11.10.2026 die Zeile oben auf Zuhause, lib/projekt-zeile.ts)
 *
 * Die Projekt-Zeile kürzt lange Namen mit „…“ („Vespera Pakete & Verbr…“ war
 * auf Martins Bild schon bei 180 Punkten abgeschnitten). Was sichtbar gekürzt
 * wird, muss anderswo ganz stehen: im `title` (Maus, langes Drücken) und im
 * `aria-label` (Vorleser lesen das Label statt des sichtbaren, gekürzten
 * Texts). Vorher stand dort das Pauschale „Aktives Projekt — zur Projektliste“
 * ohne den Namen: ein Vorleser sagte nie, WELCHES Projekt aktiv ist.
 */

/** Titel (Tooltip) und aria-label der Projekt-Zeile. */
export function projektChipBeschriftung(
  name: string,
  beschreibung?: string | null,
): { title: string; aria: string } {
  const ganz = name.trim();
  const mehr = (beschreibung ?? "").trim();
  return {
    title: `Aktives Projekt: ${ganz}${mehr ? `\n${mehr}` : ""}`,
    aria: `Aktives Projekt: ${ganz} — öffnen`,
  };
}
